/* Return null regardless of PropTypes */
import React from 'react';

export default class AutoSizeTextArea extends React.Component {
    constructor(props) {
        super(props);
        this.ta = React.createRef();
    }
    
    componentDidMount() {
        this.updateHeight();
    }

    updateHeight=()=>{
        let elem = this.ta.current;
        if (elem) {
            elem.style.height = (elem.scrollHeight) + "px";
        }
    }
    
    render() {
        return (
            <textarea {...this.props} style={{overflow:'hidden'}} ref={this.ta}/>
        )
    }
}
